import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, getToken } from 'firebase/messaging';

const config = {
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

let firebase;
let messaging;
let isBrowserCompatible = false;

async function init() {
  try {
    isBrowserCompatible = await isSupported();
    if (isBrowserCompatible) {
      firebase = initializeApp(config);
      messaging = getMessaging(firebase);
    }
  } catch (e) {
    // Nothing to do, it's most likely IE11 🙄
    // Whatever, Firebase isn't working, so it'll be disabled
    isBrowserCompatible = false;
    return false;
  }
  return true;
}

export default {
  // The intent with this is to have a Promise that will eventually resolve when Firebase is (or not) initialized
  // It's intended to be used as follow : `await firebaseInit();` even if in most cases it will resolve as soon as it is called.
  firebaseInitPromise: init(),
  get messaging() {
    return messaging;
  },
  get isBrowserCompatible() {
    return isBrowserCompatible;
  },
  getToken,
};
